// Auto-generated from server/src/Jobs.Domain/Constants/ProjectCheckpointTypeConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const ProjectCheckpointTypeConstants = {
  Review: '80f6898f-2c27-4d8a-adfe-6696cedc3bd6',
  Confirmation: 'a586bcc7-9f37-4473-b1b9-2ec3f7d5e100',
  Utilities: 'c7d4e9b2-3a1f-4e5c-8b6d-9a2f7c3e8d10'
} as const;
